module.exports = __webpack_public_path__ + "static/img/forget-pwd.7d5dd0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/forget-pwd.png
// module id = 06Ea
// module chunks = 36